__turbopack_context__.v({
  "CampaignPage": "qdXoNG_CampaignPage",
  "Container": "qdXoNG_Container",
  "OfferPage": "qdXoNG_OfferPage",
  "ReportPage": "qdXoNG_ReportPage",
  "Root": "qdXoNG_Root",
  "Title": "qdXoNG_Title",
});
